import { Component, Input, OnDestroy } from '@angular/core';
import { MessageService } from '@services/helpers/message-service/message.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { PickTimeDataProvider } from '@services/integrations/pickTime/pickTime.data.service';

@Component({
	selector: 'integrate-pic-time-modal',
	template: require('./integrate-pic-time-modal.html')
})
export class IntegratePicTimeModal implements OnDestroy {
	@Input() picTimeAccessToken: string;
	@Input() clientPortalText: string;

	button_disabled: boolean;

	private unsubscribe: Subject<void> = new Subject();

	constructor(
		private messageService: MessageService,
		private activeModal: NgbActiveModal,
		private pickTimeDataProvider: PickTimeDataProvider
	) {}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	savePicTimeSettings(): void {
		this.button_disabled = true;
		this.picTimeAccessToken
			? this.setPicTimeSettings()
			: this.updatePicTimeSettings();
	}

	changePathAfterIntegration(): void {
		this.clientPortalText = '';
		this.button_disabled = false;
		if (this.picTimeAccessToken) {
			window.history.replaceState(
				null,
				null,
				window.location.pathname.replace(
					window.location.pathname,
					'/settings/integrations'
				)
			);
		}
	}

	setPicTimeSettings(): void {
		this.button_disabled = true;
		const authObj = {
			accessToken: this.picTimeAccessToken,
			clientPortalText: this.clientPortalText
		};
		this.pickTimeDataProvider
			.savePickTimeIntegration(authObj)
			.pipe(
				finalize(() => {
					this.button_disabled = false;
				}),
				takeUntil(this.unsubscribe)
			)
			.subscribe(
				(): void => {
					this.activeModal.close(true);
					this.changePathAfterIntegration();
					this.messageService.showToaster('s_0', 'picTime');
				},
				error => this.messageService.handleError(error)
			);
	}

	updatePicTimeSettings(): void {
		this.button_disabled = true;
		const settings = {
			clientPortalText: this.clientPortalText || ''
		};

		this.pickTimeDataProvider
			.updatePicTimeIntegration(settings)
			.pipe(
				finalize(() => {
					this.button_disabled = false;
				}),
				takeUntil(this.unsubscribe)
			)
			.subscribe(
				() => {
					this.activeModal.close();
					this.messageService.showToaster('s_5', 'picTime');
				},
				error => this.messageService.handleError(error)
			);
	}
	onDismiss(): void {
		this.activeModal.close();
		this.changePathAfterIntegration();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/settings/integrations-section/modals/integrate-pic-time-modal/integrate-pic-time-modal.ts